import { withFormik } from 'formik'

import CoachingExperienceChunk from './chunks/CoachingExperienceChunk'
import { genValueMapper }      from './form-utils'
import { asFormStep }          from './wrappers'

const formik = {
  handleSubmit:     (values, bag) => {
    bag.resetForm()
    bag.props.onSubmit(values)
  },
  mapPropsToValues: genValueMapper({ coachingExperience: [] }),
}

export default withFormik(formik)(asFormStep(CoachingExperienceChunk))



// WEBPACK FOOTER //
// ./src/components/forms/CoachingExperienceFormStep.tsx